import Spinner from './Spinner';

export { Props } from './Spinner';
export default Spinner;
